import friendlyInd from "~/assets/cities/friendly-ind.png";
import hotInd from "~/assets/cities/hot-ind.png";
import postCount from "~/assets/cities/post-count.png";
import friendlyIndsm from "~/assets/cities/friendly-ind-sm.png";
import hotIndsm from "~/assets/cities/hot-ind-sm.png";
import postCountsm from "~/assets/cities/post-count-sm.png";

const CityTags = ({ city, className = "" }: any) => {
  return (
    <div className={`city-tag-wrapper ${className}`}>
      <div className="tag">
        <img src={friendlyInd.src} className="normal" />
        <img src={friendlyIndsm.src} className="small" />
        <span>旅居友好</span>
        <span>
          {(
            (Object.values(city.indexes) as number[]).reduce(
              (sum, value) => sum + value,
              0
            ) / Object.values(city.indexes).length
          ).toFixed(1)}
        </span>
      </div>
      <div className="tag">
        <img src={hotInd.src} className="normal" />
        <img src={hotIndsm.src} className="small" />
        <span>热度</span>
        <span>
          {city.views_count > 1000
            ? `${(city.views_count / 1000).toFixed(1)}k`
            : city.views_count}
        </span>
      </div>
      <div className="tag">
        <img src={postCount.src} className="normal" />
        <img src={postCountsm.src} className="small" />
        <span>帖子</span>
        <span>{city.posts_count}</span>
      </div>
    </div>
  );
};
export default CityTags;
